import React, { useCallback, useEffect, useState } from "react";
import AdminShell from "../../Components/admin/AdminShell";
import { fetchAdminVolunteerApplications } from "../../services/siteFormsApi";
import "../../Components/admin/adminDashboard.css";

function formatValue(v) {
  const s = v == null ? "" : String(v).trim();
  return s || "—";
}

function isPlaceholderDash(v) {
  const s = v == null ? "" : String(v).trim();
  return s === "" || s === "—";
}

export default function AdminVolunteers() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const list = await fetchAdminVolunteerApplications();
      setRows(list);
    } catch (e) {
      setError(e?.message || "Could not load volunteer applications.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <AdminShell title="Volunteers" subtitle="Volunteer program applications">
      {error ? (
        <div className="adminCard" style={{ padding: 14, marginBottom: 16, color: "#b91c1c", fontWeight: 600 }}>
          {error}
        </div>
      ) : null}

      <div className="adminCard">
        {loading ? (
          <div className="adminVolunteerList">
            {[0, 1, 2].map((i) => (
              <div key={i} className="adminVolunteerCard" aria-hidden="true">
                <div className="adminSkeleton" style={{ width: "45%", height: 14 }} />
                <div className="adminSkeleton" style={{ width: "100%", height: 10, marginTop: 14 }} />
                <div className="adminSkeleton" style={{ width: "72%", height: 10, marginTop: 8 }} />
              </div>
            ))}
          </div>
        ) : rows.length === 0 ? (
          <div className="adminEmpty" style={{ padding: 20 }}>
            No applications yet.
          </div>
        ) : (
          <div className="adminVolunteerList">
            {rows.map((r) => (
              <article key={r.id} className="adminVolunteerCard">
                <div className="adminVolunteerCardHead">
                  <h2 className="adminVolunteerCardName">{formatValue(r.name)}</h2>
                  <time className="adminVolunteerCardDate" dateTime={r.createdAt || undefined}>
                    {r._displayDate}
                  </time>
                </div>
                <div className="adminVolunteerGrid">
                  <div className="adminVolunteerField">
                    <span className="adminVolunteerFieldLabel">Phone</span>
                    <div className="adminVolunteerFieldValue">{formatValue(r.phone)}</div>
                  </div>
                  <div className="adminVolunteerField">
                    <span className="adminVolunteerFieldLabel">Email</span>
                    <div className="adminVolunteerFieldValue">
                      {!isPlaceholderDash(r.email) ? (
                        <a className="adminLink" href={`mailto:${r.email}`}>
                          {r.email}
                        </a>
                      ) : (
                        "—"
                      )}
                    </div>
                  </div>
                  <div className="adminVolunteerField">
                    <span className="adminVolunteerFieldLabel">Country</span>
                    <div className="adminVolunteerFieldValue">{formatValue(r.country)}</div>
                  </div>
                  <div className="adminVolunteerField">
                    <span className="adminVolunteerFieldLabel">Occupation</span>
                    <div className="adminVolunteerFieldValue">{formatValue(r.occupation)}</div>
                  </div>
                  <div className="adminVolunteerField">
                    <span className="adminVolunteerFieldLabel">Interest</span>
                    <div className="adminVolunteerFieldValue">{formatValue(r.areaOfInterest)}</div>
                  </div>
                </div>
                <div className="adminVolunteerNotesBlock">
                  <span className="adminVolunteerFieldLabel">Notes</span>
                  {!isPlaceholderDash(r.additionalInfo) ? (
                    <div className="adminVolunteerNotesBody">{r.additionalInfo}</div>
                  ) : (
                    <p className="adminVolunteerNotesEmpty">No notes provided.</p>
                  )}
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </AdminShell>
  );
}
